import React from 'react';

export const defaultContext = {};

export const AdminContext = React.createContext(defaultContext);
